var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Flex } from "./..";
import { TableCell } from './DataTableComponents';
/**
 * FooterCell is generated based on the Column passed to the DataTable component
 */
export function FooterCell(_a) {
    var dataKey = _a.dataKey, footerRenderer = _a.footerRenderer, width = _a.width, footerCellLss = _a.footerCellLss, data = _a.data;
    var getColumnData = function (data, dataKey) {
        return data.map(function (item) { return item[dataKey]; });
    };
    return (React.createElement(TableCell, { as: "th", lss: __assign({ width: width }, footerCellLss) }, typeof footerRenderer === 'function' ? (footerRenderer(getColumnData(data, dataKey), data)) : (React.createElement(Flex, { lss: {
            alignItems: 'center'
        } }, footerRenderer))));
}
//# sourceMappingURL=FooterCell.js.map